import { EditProcessRequestSchema, EditProcessResponseSchema } from './edit-process.schema';
/**
 * Sign In Endpoint Contract
 * Authenticates a user and returns a JWT token
 */ export const editProcessContract = {
    method: 'PATCH',
    path: '/api/v2/process/:id',
    description: 'Edit process entity fields',
    requestSchema: EditProcessRequestSchema,
    responseSchema: EditProcessResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Invalid credentials or user not found',
            400: 'Invalid request body'
        }
    }
};

//# sourceMappingURL=edit-process.contract.js.map